import { FontVariant } from '@luminovo/design-system';
import type { JSX } from 'react';

import { GenericLabel } from './GenericLabel';

export const ResourceLabel = ({
    resourceName,
    site,
    variant,
}: {
    resourceName: string;
    site: string | undefined;
    variant?: FontVariant;
}): JSX.Element => <GenericLabel variant={variant} name={resourceName} additionalInfo={site} />;
